if (!window.woenixWriteReviewLoaded) {
  window.woenixWriteReviewLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.woenix-write-review');
    if (!link) return;
    const open = () => {
      const widget = document.getElementById('judgeme_product_reviews');
      const button = widget?.querySelector('.jdgm-write-rev-link') || Array.from(widget?.querySelectorAll('button') || []).find(button => button.textContent.trim().toLowerCase() === link.textContent.trim().toLowerCase());
      if (!button) return false;
      button.click();
      widget.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
      return true;
    };
    if (open()) { event.preventDefault(); return; }
    const observer = new MutationObserver(() => { if (open()) observer.disconnect(); });
    observer.observe(document.body,{childList:true,subtree:true});
    setTimeout(() => observer.disconnect(),8000);
  });
}